import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const FaqManagement = ({ children }) => {
  const Navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin/faq") {
      Navigate("/admin/faq/faq-tables");
    }
  }, [location, Navigate]);

  return (
    <div className="mt-4 ">
      <section>
        <div className="container">
          <div className="row">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FaqManagement;
